export default "__VITE_ASSET__CsUDbciQ__"